import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import type { IFetchService } from "app/services/fetchService";

import type { IAccountSettingsApiService } from "./types";

const ACCOUNT_SETTINGS_URL = `${SALES_API_BASE_URL}/account-settings`;
const EXTENSION_DEFAULTS_URL = `${ACCOUNT_SETTINGS_URL}/extension-defaults`;

type SettingsScope = "Platform" | "ChromeExtension";
const getExtensionSettingsScope = (scope: SettingsScope) => `scope=${scope}`;

const createAccountSettingsApiService = (fetchService: Readonly<IFetchService>): IAccountSettingsApiService => {
    return {
        fetchSetting(key, options?) {
            return fetchService.get(`${ACCOUNT_SETTINGS_URL}/${key}`, undefined, options);
        },

        saveSetting(key, value, options?) {
            return fetchService.put(`${ACCOUNT_SETTINGS_URL}/${key}?value=${value}`, undefined, options);
        },

        fetchExtensionDefaults(options?) {
            return fetchService.get(`${EXTENSION_DEFAULTS_URL}`, undefined, options);
        },

        saveExtensionDefaults(payload, options?) {
            return fetchService.put(
                `${EXTENSION_DEFAULTS_URL}?${getExtensionSettingsScope("ChromeExtension")}`,
                payload,
                options,
            );
        },
    };
};

export default createAccountSettingsApiService;
